export default "__VITE_ASSET__419a069f__"